var map = {
	"./Logo Image-1.png": 7076,
	"./Logo Image-10.png": 8894,
	"./Logo Image-2.png": 3935,
	"./Logo Image-3.png": 6998,
	"./Logo Image-4.png": 7081,
	"./Logo Image-5.png": 2608,
	"./Logo Image-6.png": 939,
	"./Logo Image-7.png": 6114,
	"./Logo Image-8.png": 6965,
	"./Logo Image-9.png": 1052,
	"./Logo Image.png": 6702,
	"./Partner Logo-1.png": 4357,
	"./Partner Logo-2.png": 6206,
	"./Partner Logo-3.png": 5575,
	"./Partner Logo-4.png": 4056,
	"./Partner Logo-5.png": 8673,
	"./Partner Logo-6.png": 9690,
	"./Partner Logo-7.png": 8547,
	"./Partner Logo-8.png": 2628,
	"./Partner Logo-9.png": 3757,
	"./Partner Logo.png": 9571
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4387;